// 根据表单规则生成对应的UI
import GroupImages from '../components/Complex/GroupImages'
import { getRules } from '@/components/prod/center/components/TBInfoForm/utils/rules'
import { typeMap } from './fields'
import { reversValue, wireless_desc2form,new_wireless_desc2form } from './data'
import { genIsShowFn } from './disableRule'
import _ from 'lodash'
import dayjs from 'dayjs'
import store from '@/store'

export const needShowMultiComplexFields = ['packList', 'cspuList', 'material_prop_149422948'] // 一些schema返回的非必填的，但是不填又报错的MultiComplex表单域，这种先展示渲染为Complex使其可以填写一组数据

// COMPLEX类型的控件的必填校验取消掉，因为还要继续分解控件的，他的必填暂时无法通过el-form的校验
function complexRequireRuleFormat(item) {
  const requireRuleIndex = item.rules.findIndex(r => r?.required)
  if (item.type === 'COMPLEX' && requireRuleIndex > -1) {
    item.rules.splice(requireRuleIndex, 1)
  }
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
  return (rule, value, callback) => fn(rule, value, callback, context)
}

// 处理第三步的价格
function vali_step3_price (rules, val, cb, context) {
  if (!context?.form?.pureType && context.$refs.sku) {
    const skuList = context.$refs.sku[0].skuList || []
    let hasSamePrice = false
    skuList.forEach((sku) => {
      let sku_price = sku.sku_price
      if (hasSamePrice) return;
      if (sku_price && Number(sku_price) === Number(val)) {
        hasSamePrice = true
      }
    })
    if (!hasSamePrice) {
      return cb(new Error('需要是商品明细中的价格之一'))
    } 
    cb()
  } else {
    cb()
  }
}

// 处理第三步开始时间
function vali_step3_start_time (rules, val, cb) {
  if (!val) return cb()

  if (dayjs(val, 'YYYY-MM-DD HH:mm:ss').diff(dayjs()) < 600000) {
    cb(new Error('请至少设置10分钟之后的时间'))
  } else {
    cb()
  }
}

// 处理生成html类型的规则
function getHtmlRules(item) {
  let _rules = item.rules || {}
  const {maxLengthRule, minLengthRule, requiredRule} = _rules
  if (minLengthRule && item?.component?.props) {
    item.component.props.placeholder = `至少${minLengthRule}个字符`
  }

  return [{
    validator: (rules, value, callback) => {
      if (requiredRule === 'true' && !value) {
        return callback(new Error('必填'))
      }
      if (!maxLengthRule && !minLengthRule) {
        return callback()
      }
      
      let div = document.createElement('div')
      div.innerHTML = value
      let imgs = Array.from(div.getElementsByTagName('img'))

      if (minLengthRule) {
        if (imgs.length) return callback()
        if (!div.innerText.length && requiredRule !== 'true' && !["description"].includes(item.name)) {
          return callback()
        }
        if (div.innerText.length < minLengthRule) {
          return callback(new Error('不能少于' + minLengthRule + '字符'))
        }
      }

      if (maxLengthRule) {
        if (div.innerText.length > maxLengthRule) {
          return callback(new Error('不能超过' + maxLengthRule + '字符'))
        }
      }
      
      callback()
    }
  }]

}

// 特殊处理一些字段的校验规则
function ruleSpecial(item) {
  if (['location', 'prov', 'city'].includes(item.name)) {
    // 所在地相关的必填规则处理
    if (item.name === 'location') {
      // 移除所在地的必填校验
      delete item.rules.requiredRule
    } else {
      // 给省、市加入必填校验
      item.rules.requiredRule = "true"
    }
  }
  if (['item_images', 'express_fee', 'post_fee', 'ems_fee', 'std_size_group'].includes(item.name)) {
    item.rules.requiredRule = "true"
  }
  if ('freight' === item.name) {
    delete item.rules.requiredRule
  }

  return item
}


// 第一步的表单UI
export function step1FormUI(schema) {
  const propsNames = Object.keys(schema)
  let uiForm = propsNames.map(propName => {
    let item = schema[propName]
    item._step = '1'
    genIsShowFn(item, schema)
    item.rules = getRules(item)
    item.component = typeMap[item.type](_.cloneDeep(item))
    return item
  })
  return uiForm
}

// 第二步的表单UI及表单
// 将prop_开头的字段集合一起ui.props，其余的集合一起ui.others，用于分别渲染
export function step2FormUI(ori_schema, ori_data) {
  let schema = _.cloneDeep(ori_schema)
  let {fieldDescriptorList = []} = _.cloneDeep(ori_data)
  const ui = {
    props: [],
    others: []
  }
  const form = {}

  // 给每一项及它的子项添加一些相关信息
  // _step -> 当前项是在步骤几
  // rules -> 这一项的表单校验规则
  // parentName -> 父项的name
  // component -> 此项的渲染组件
  const formatItem = (item, parentName = '', defaultData = null) => {
    item.rules = item.rules || {}
    const isNeedShowMultiComplexField = needShowMultiComplexFields.includes(item.name) || item.rules?.requiredRule === 'true'
    if (['MULTICOMPLEX', 'LABEL'].includes(item.type) && !isNeedShowMultiComplexField) return false // 暂时不支持这类型字段的展示
    if (['COMPLEX'].includes(item.type)) {
      if(item?.children.length) {
        item.rules = {}
      } else {
        // COMPLEX类型，无children隐藏该字段
        return false
      }
    }
    if (item.children?.length) {

      item.children = item.children.map(ic => {
        return formatItem(ic, item.name, defaultData?.children?.length ? defaultData.children.find(d => d.name === ic.name) : null)
      }).filter(Boolean)
      if (item.type === 'MULTICOMPLEX') {
        // 给多实例复合型表单赋值
        form[item.name] = (defaultData?.children || []).map(cv => {
          let cvform = {}
          cv.children.forEach((defaultData) => {
            cvform[defaultData.name] = reversValue(defaultData)
          })
          return cvform
        })
      }
    } else {
      // 给表单赋值
      form[item.name] = defaultData ? reversValue(defaultData, item) : undefined
    }

    item._step = '2'
    item.parentName = parentName
    item.component = typeMap[item.type](_.cloneDeep(item))
    genIsShowFn(item, schema)
    item.rules = getRules(item)
    return item
  }

  let in_prop_map = {}
  for (const key in schema) {
    if (/^prop_/.test(key) || /^in_prop_/.test(key)) {
      if (/^in_prop_/.test(key)) {
        in_prop_map[key] = schema[key]
        continue
      }
      ui.props.push(formatItem(schema[key], '', fieldDescriptorList.find(item => item.name === key)))
    } else {
      ui.others.push(formatItem(schema[key], '', fieldDescriptorList.find(item => item.name === key)))
    }
  }
  ui.props = ui.props.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  ui.others = ui.others.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  // 将in_prop_开头的字段塞到对应prop_开头字段的后面
  // 没有就放最后
  for (const in_key in in_prop_map) {
    const _key = in_key.replace(/^in_/, '')
    let ui_index = ui.props.findIndex(({name}) => name === _key)
    if (ui_index > -1) {
      ui.props.splice(ui_index + 1, 0, formatItem(in_prop_map[in_key], '', fieldDescriptorList.find(item => item.name === in_key)))
    } else {
      ui.props.push(formatItem(in_prop_map[in_key], '', fieldDescriptorList.find(item => item.name === in_key)))
    }
  }
  
  return [ui, form]
}

// 第三步的表单ui及表单
// 表单基本组成：
// 1. 商品属性 --- 取所有prop_开头的字段
// 2. 属性库存信息 --- 商品规格、商品价格、商品数量、商家外部编码、条形码
// 3. 商品物流信息 --- 商品物流重量体积、所在地
// 4. 商品描述 --- 商品标题、商品图片、商品无线图片、透明素材图、电脑端描述、手机端描述(只支持图片）、页面模板
// 5. 售后及其他 --- 发票、保修、退换货服务、商品状态、售后服务、售后说明、会员让利、拍下减库存、返点比例、上架时间
// 模特试穿信息
const getAuctionVideosValue = (data) => {
  const valueList = (data?.children || []).map(children => {
    const childrenSVideoItem = children.children.find(child => child.name === 'videoId') || {};
    const { defaultValue, extendValue }  = childrenSVideoItem
    if (!defaultValue || !extendValue || !extendValue[defaultValue] || !extendValue[defaultValue].videoInfoJson) {
      return {};
    }
    const childrenSVideoItemVideoType = children.children.find(child => child.name === 'videoType') || {};
    const videoInfoJson = JSON.parse(extendValue[defaultValue].videoInfoJson || {});
    return {
      ...videoInfoJson,
      videoInfoJson,
      videoType: childrenSVideoItemVideoType.defaultValue || ''
    };
  });
  return valueList
}

export function step3FormUI(ori_schema, ori_data) {
  if(!ori_schema) return []
  const context = this
  let schema = _.cloneDeep(ori_schema)
  schema['useGroupImages'] = {name: 'useGroupImages',label: "引用套图"}
  let defaut_ori_data = _.cloneDeep(ori_data[0])
  let {fieldDescriptorList = [], specifications, itemSkuList, pureType} = defaut_ori_data

  // 运费模板id要特殊处理
  let postage_id_data = ori_data.reduce((map, curr) => {
    // 找到当前店铺的模板id
    let curr_postage_id = (curr.fieldDescriptorList || []).find(field => field.name === 'postage_id')
    map[curr.shopId] = curr_postage_id ? curr_postage_id.defaultValue : undefined
    return map
  }, {})

  const ui = {
    props: [], // 商品属性
    specifications: [
      'std_size_group', // 尺码组
      'sku', // 商品规格
      'price', //商品价格
      'quantity', // 商品数量
      'outer_id', // 商家外部编码
      'sku_barcode', // 条形码
      'size_model_try',
    ], // 属性库存信息
    logistics: [
      'item_size_weight', // 商品物流重量体积
      'location', // 所在地
      'delivery_way', // 提取方式
      'freight_payer', // 运费承担方式
      'freight_by_buyer', // 买家承担运费
      'postage_id', // 运费模版id
      'freight', // 运费
    ], // 物流信息
    description: [
      'title', // 商品标题
      'shopping_title', // 导购标题
      'sell_points', // 商品卖点
      'useGroupImages', // 引用套图
      'item_images', // 商品图片
      'three_to_four_item_images', // 3:4商品图片
      'vertical_image', // 商品竖图
      'item_wireless_images', // 商品无线图片
      'white_bg_image', // 透明素材图
      'item_attach_images', // 商品资质图片
      'diaopai_pic', // 吊牌图
      'auctionVideos', // 商品视频
      'inner_shop', // 页面模板
      'wireless_desc', // 手机端描述 --- 只取图片需要特殊处理
      'description', // PC端描述
      'seller_cids', // 店铺类目
    ], // 商品描述
    others: [
      'has_invoice', // 发票
      'has_warranty', // 保修
      'sell_promise', // 退换货服务
      'sub_stock', // 拍下减库存
      'has_discount', // 是否支持会员折扣
      'auction_point', // 返点比例
      'item_status', // 商品状态
      'start_time', // 开始时间
      'ccc_certificate_no', // 3C证书
      'food_images', // 食品安全图片
      'food_security.food_nutrition_table', // 营养成分表
      'food_security.organic_food', // 有机食品
      'food_security.organic_certification', // 有机证书编号
      'food_security.is_green_food', // 绿色食品
      'food_security.green_food_level', // 绿色食品等级
      'food_security.green_food_produce_number', // 绿色产品编号
      'food_security.period',   // 保质期
      'food_security.product_date',   // 生产日期
      'food_security.mix',   // 配料表
      'food_security.prd_license_no',   // 生产许可证编号
      'material_prop_149422948',   // 材质成分
      'food_security.factory',   // 厂名
      'food_security.factory_site',   // 厂址
    ], // 售后及其他
  }
  const needHideFields = ['service_version'] // 需要隐藏的字段
  const form = {
    baseItemId: defaut_ori_data.baseItemId,
    categoryIds: defaut_ori_data.categoryIds,
  }
  // 给每一项及它的子项添加一些相关信息
  // _step -> 当前项是在步骤几
  // rules -> 这一项的表单校验规则
  // parentName -> 父项的name
  // component -> 此项的渲染组件
  const formatItem = (item, parentName = '', defaultData = null) => {
    item.rules = item.rules || {}
    // 对于name字段中含有.的进行替换为_____（5个下划线），不然在el-form-item中prop属性时会报错（这个属性路径是嵌套的，form中又不是嵌套的，所以会报错）
    if(/\./.test(item.name)) {
      item.name = item.name.replaceAll('.', '_____')
    }
    // 特殊处理的字段 开始
    if (item.name === 'sku') {
      // 规格信息需要沿用之前组件，特殊处理
      item.component = typeMap[item.type](_.cloneDeep(item))
      const stdSizeKey = Object.keys(schema).find(key => key.startsWith('std_size_extends_'))
      if(stdSizeKey) {
        item.component.props.stdSizeExtends = schema[stdSizeKey]  // 尺码组
        const size_tip = schema[stdSizeKey]?.children?.find(item => item.name === 'size_tip') // 尺码备注
        if(size_tip) {
          size_tip.name = 'prop_remark'
          store.dispatch("updateExtendsFields", {
            'prop_remark': [size_tip]
          })
        }
      }
      form.specifications = _.cloneDeep(specifications)
      form.skuList = itemSkuList;
      return item
    }
    // 直接返回
    if (item.name === 'size_model_try') {
      let sizeModelTrySource = fieldDescriptorList.find(d => d.name === item.name);
      item.component = { component: typeMap[item.type](_.cloneDeep(item))?.component, props: { value: sizeModelTrySource, columns: item }}
      return item;
    }
    if (item.name === 'wireless_desc') {
      item.component = typeMap[item.type](_.cloneDeep(item))
      // item.rules = []
      item.rules = getRules(item)
      if(defaut_ori_data.newWirelessDesc){ // 新版无线端详情描述
        form['wireless_desc'] = new_wireless_desc2form(defaultData, item)
      }else{
        form['wireless_desc'] = wireless_desc2form(defaultData, item)
      }
      return item
    }
    if(item.name === 'useGroupImages') {
      item.component = { component: GroupImages, props: { dataSource: item, name: item.name, parentName } }
      item.rules = []
      form.showGroupImages = true;
      return item
    }
    if (['item_images', 'item_wireless_images', 'three_to_four_item_images'].includes(item.name)) {
      item.component = typeMap[item.type](_.cloneDeep(item))
      form[item.name] = defaultData?.children?.length ?  defaultData.children.map(c => c.defaultValue) : []
      item.rules = getRules(ruleSpecial(item))
      return item
    }
    if (item.name === 'postage_id') {
      item.component = typeMap[item.type](_.cloneDeep(item))
      genIsShowFn(item, schema)
      item.rules = []
      form['postage_id'] = postage_id_data
      return item
    }
    if (item.name === 'auctionVideos') {
      item.component = typeMap[item.type](_.cloneDeep(item))
      form['auctionVideos'] = getAuctionVideosValue(defaultData);
      item.rules = []
      return item
    }
    if(item.name === 'sell_point_0') {
      item.rules.maxLengthRule = 40
    }

    // pc端详情描述，从其他平台同步过来的值，取defaultValue，
    if (item.name === 'description' && defaut_ori_data['pcDescGetRule'] === 'defaultValueList' && defaultData.defaultValue) {
      try {
        const defaultVal = JSON.parse(defaultData.defaultValue);
        if(Array.isArray(defaultVal)) {
          if(item.children?.length) {
            const children = _.cloneDeep(item.children);
            children[0].children.forEach(item => {
              if(item.name.includes('_cat_mod_content')) {
                item.defaultValue = defaultVal.map(src => `<img src="${src}" width="790"/>`).join('')
              }
            }) 
            defaultData.children = children
            defaultData.defaultValue = null
          } else {
            defaultData.defaultValue = defaultVal.map(src => `<div style="text-align: center"><img src="${src}"/></div>`).join('')
          }
        }
      } catch (error) {}
    }
    // 特殊处理的字段 结束

    const isNeedShowMultiComplexField = needShowMultiComplexFields.includes(item.name) || item.rules?.requiredRule === 'true'
    if (['MULTICOMPLEX', 'LABEL'].includes(item.type) && !isNeedShowMultiComplexField) return false // 暂时不支持这类型字段的展示
    if (needHideFields.includes(item.name)) return false // 需要隐藏的字段
    if (item.children?.length) {
      item.children = item.children.map(ic => {
        return formatItem(ic, item.name, defaultData?.children?.length ? defaultData.children.find(d => d && d.name === ic.name) : null)
      }).filter(Boolean)
      if (item.type === 'MULTICOMPLEX') {
        // 给多实例复合型表单赋值
        form[item.name] = (defaultData?.children || []).map(cv => {
          let cvform = {}
          cv.children.forEach((d) => {
            cvform[d.name] = reversValue(d)
          })
          return cvform
        })
      }
    } else {
      // 给表单赋值
      form[item.name] = defaultData ? reversValue(defaultData, item) : undefined
    }

    item._step = '3'
    item.parentName = parentName
    item.component = typeMap[item.type](_.cloneDeep(item))
    genIsShowFn(item, schema)
    if (/html/.test(item.rules?.valueTypeRule)) {
      // html 的规则需要自定义一下
      item.rules = getHtmlRules(item)
    } else {
      item.rules = getRules(ruleSpecial(item))

      if (item.name === 'start_time') {
        // 开始时间需要特殊处理，需要校验时间不能小于当前时间超过10分钟
        item.rules.push({validator: vali_step3_start_time})
      }

      if (item.name === 'price') {
        // 商品价格的校验需要特殊处理，需要sku表中其中一个等于不为0的sku的价格
        // if(!defaut_ori_data.pureType) {
          item.rules.push({validator: contextWrap(vali_step3_price, context)})
        // }
      }
      if (item.name === 'quantity') {
        item.component.props.disabled = true;
      }

    }

    complexRequireRuleFormat(item)
    // 尺码分组没有值的时候默认值处理
    if (item.name === 'std_size_group') {
      let val = form[item.name];
      const options = item.options || [];
      const isValueInOptions = options.some(op => op.value === val);

      if (!isValueInOptions) {
        const defaultValue = item.defaultValue;
        form[item.name] = options.some(op => op.value === defaultValue) ? defaultValue : options[0]?.value;
      }
    }

    return item
  }

  store.dispatch("clearExtendFields"); // 清空历史拓展字段

  let keyIndex = -1
  let in_prop_map = {}
  let requiredProps = []
  let noRequiredProps = []
  for (const key in schema) {
    const uiItem = formatItem(schema[key], '', fieldDescriptorList.find(item => item.name === key))
    if (/^prop_/.test(key) || /^in_prop_/.test(key)) {
      if (/prop_extend_/.test(key)) {
        store.dispatch("updateExtendsFields", {
          [key.replace('_extend', '')]: schema[key].children || []
        })
        continue;
      }
      if (/^in_prop_/.test(key)) {
        in_prop_map[key] = schema[key]
        continue
      }
      if(uiItem._oriRules?.requiredRule === 'true') {
        requiredProps.push(uiItem)
      } else {
        if(!noRequiredProps.length) {
          uiItem.firstNoRequired = true
        }
        noRequiredProps.push(uiItem)
      }
    } else if ((keyIndex = ui.specifications.indexOf(key)) > -1 ) {
      ui.specifications[keyIndex] = uiItem
    } else if ((keyIndex = ui.logistics.indexOf(key)) > -1 ) {
      ui.logistics[keyIndex] = uiItem
    } else if ((keyIndex = ui.description.indexOf(key)) > -1 ) {
      ui.description[keyIndex] = uiItem
    } else if ((keyIndex = ui.others.indexOf(key)) > -1 ) {
      ui.others[keyIndex] = uiItem
    } else if (uiItem._oriRules?.requiredRule === 'true' && !/^in_prop_/.test(key)) {
      ui.others.push(uiItem)
    }
  }
  ui.props = [...requiredProps, ...noRequiredProps]
  // 将in_prop_开头的字段塞到对应prop_开头字段的后面
  // 没有就放最后
  for (const in_key in in_prop_map) {
    const _key = in_key.replace(/^in_/, '')
    let ui_index = ui.props.findIndex(({name}) => name === _key)
    if (ui_index > -1) {
      ui.props.splice(ui_index + 1, 0, formatItem(in_prop_map[in_key], '', fieldDescriptorList.find(item => item.name === in_key)))
    } else {
      ui.props.push(formatItem(in_prop_map[in_key], '', fieldDescriptorList.find(item => item.name === in_key)))
    }
  }

  ui.props = ui.props.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  ui.specifications = ui.specifications.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  ui.logistics = ui.logistics.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  ui.description = ui.description.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  ui.others = ui.others.filter(item => (Boolean(item)) && (typeof item !== 'string'))
  return [ui, form]
}

// 第三步中的规格拓展字段需要生成UI
export function step3ExtendsUI (fields) {
  const formatItem = (item) => {
    item.rules = item.rules || {}

    /**
     * 拓展字段暂不支持复合类型，若出现了再做处理，涉及到样式及数据组合校验相关
     */
    if (['MULTICOMPLEX', 'COMPLEX'].includes(item.type)) return false // 暂时不支持这类型字段的展示

    item.component = typeMap[item.type](_.cloneDeep(item))
    item.rules = getRules(_.cloneDeep(item))

    return item
  }

  return _.cloneDeep(fields).map((item) => formatItem(item));
}
